import React from "react";
import PropTypes from "prop-types";
import styled from "@emotion/styled";
import { isUserType, removeUserDetails } from "../../../utils/services/methods";
import { Link } from "gatsby";

import { theme } from "../../../utils/global-styles/theme";

const DashboardDropdown = ({ dropdownLinks, locale }) => {
  const isFellow = isUserType("Fellow");
  const isFoundry = isUserType("Foundry");
  const DropdownContainer = styled.div`
    display: none;
    position: absolute;
    border-radius: 3px;
    box-shadow: 0 0 4px 2px rgba(0, 0, 0, 0.17);
    z-index: 6;
    font-weight: normal;
    flex-direction: column;
    justify-content: space-around;

    a {
      color: ${theme.colors.white};
      padding: .5em;
    }
  `;

  const DashboardLink = styled(Link)`
      font-size: 1em;
      font-weight: 500;
      line-height: 1.25em;
      border-bottom: 1px solid ${theme.colors.white};
    `,
    DashboardLogoutLink = styled("a")`
      font-size: 1em;
      font-weight: 500;
      line-height: 1.25em;
    `;

  return (
    <DropdownContainer className="dashboard-dropdown-content">
      {dropdownLinks?.map((link, index) => {
        if (!link.url.includes("/logout")) {
          if (
            (link.url.toLowerCase().trim() === "/dashboard?foundry" ||
              link.url.toLowerCase().trim() === "/dashboard/es?foundry") &&
            !isFoundry
          ) {
            return null;
          }
          if (
            (link.url.toLowerCase().trim() === "/dashboard?community" ||
              link.url.toLowerCase().trim() === "/dashboard/es?community") &&
            isFoundry
          ) {
            return null;
          }
          return (
            <DashboardLink to={`${link.url}`} key={index} locale={locale}>
              {link.linkText}
            </DashboardLink>
          );
        } else {
          return (
            <DashboardLogoutLink
              onClick={() => {
                removeUserDetails();
              }}
              key={index}
              href={link.url}
            >
              {link.linkText}
            </DashboardLogoutLink>
          );
        }
      })}
    </DropdownContainer>
  );
};

DashboardDropdown.propTypes = {
  dropdownLinks: PropTypes.arrayOf(
    PropTypes.shape({
      title: PropTypes.string,
      url: PropTypes.string,
    })
  ),
};

export default DashboardDropdown;
